const Common = {


  init() {
    Common.events();
  },

  events() {

  },


};

export default Common;
